import { render, staticRenderFns } from "./editPersonInChargeModal.vue?vue&type=template&id=55eed7ec&scoped=true"
import script from "./editPersonInChargeModal.vue?vue&type=script&lang=js"
export * from "./editPersonInChargeModal.vue?vue&type=script&lang=js"
import style0 from "./editPersonInChargeModal.vue?vue&type=style&index=0&id=55eed7ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55eed7ec",
  null
  
)

export default component.exports